import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { G_API } from "../../constants/globalVar";
import ReactGA from 'react-ga4';
import SocialShareButtons from "../Button/SocialShareButtons";

export default function DetailPage() {
    const { id } = useParams();
    const [item, setItem] = useState(null);
    const [formattedDateStart, setFormattedDateStart] = useState("");
    const [formattedDateEnd, setFormattedDateEnd] = useState("");
    const [imageError, setImageError] = useState(false);

    useEffect(() => {
        const config = {
            method: "post",
            maxBodyLength: Infinity,
            url: `${G_API}job-vacancies/JOB_VACANCY_LIST?id=${id}`,
            headers: {},
            data: "",
        };

        axios(config)
            .then((response) => {
                const item = response.data.DATAS;
                setItem(item);
                setFormattedDateStart(item.post_date.substring(0, 10));
                setFormattedDateEnd(item.end_date.substring(0, 10));
            })
            .catch((error) => {
                console.error(error);
            });
    }, [id]);

    const handleImageError = () => {
        setImageError(true);
    };

    function openShare() {
        ReactGA.event({
            category: 'Job Vacancy',
            action: 'job_share_btn_clicked',
            label: item ? item.title : 'Job Vacancy Share',
        });
    }

    function openApply() {
        ReactGA.event({
            category: 'Job Vacancy',
            action: 'job_apply_btn_clicked',
            label: item ? item.title : 'Job Vacancy Apply',
        });
    }

    function openReadMore() {
        ReactGA.event({
            category: 'Job Vacancy',
            action: 'job_read_more_btn_clicked',
            label: item ? item.title : 'Job Vacancy Read more',
        });
    }

    return (
        <>
            {item ? (
                <div>
                    <div id="header-carousel" className="carousel slide" data-bs-ride="carousel">
                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                {item.cover_img?.src && !imageError ? (
                                    <img
                                        className="w-100 small-slider"
                                        src={item.cover_img.src}
                                        alt="Cover"
                                        onError={handleImageError}
                                    />
                                ) : (
                                    <img
                                        className="w-100 small-slider"
                                        src="/assets/images/anyar-logo.jpg"
                                        alt="Cover"
                                    />
                                )}
                                <div className="carousel-caption">
                                    <div className="container">
                                        <div className="row justify-content-center">
                                            <div className="col-lg-7 pt-0">
                                                <h1 className="display-4 text-white mb-1 mt-2 pt-2 animated slideInDown">
                                                    {item.title}
                                                </h1>
                                                <p className="fs-5 text-white-50 mb-5 animated slideInDown">
                                                    Join us and contribute to our dynamic team!
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="container">
                        <div className="container my-4">
                            <div className="row">
                                <div className="col">
                                    <a href="/" style={{ textDecoration: "none", color: "#000" }}>
                                        Home
                                    </a>{" "}
                                    /{" "}
                                    <a href="/job-vacancy" style={{ textDecoration: "none", color: "#000" }}>
                                        Job Vacancy
                                    </a>{" "}
                                    /{" "}
                                    <span style={{ textDecoration: "none", color: "#FF6F0F" }}>
                                        {item.title}
                                    </span>
                                </div>
                            </div>

                            <div className="row">

                                <div className="col">
                                    <div className="py-4">
                                        <h2 className="mb-4">{item.title}</h2>

                                        <h5>Vacancy Number: <span>{(item.job_id && item.job_id !== 'undefined') ? item.job_id : '-'}</span></h5>
                                        <h5>Job Title: <span>{item.title}</span></h5>
                                        <h5>Supervisory Responsibility: {item.supervisory_responsibility}</h5>
                                        <h5>Department: {item.department}</h5>
                                        <h5>Job Type: <span>{item.job_type}</span></h5>
                                        <h5>Relocation: <span>{item.relocation}</span></h5>
                                        <h5>Posted By: {item.posted_by}</h5>
                                        <h5>Post Date: <span>{formattedDateStart}</span></h5>
                                        <h5>Application Deadline: <span>{formattedDateEnd}</span></h5>
                                        <h5>Report To: {item.report_to}</h5>
                                        <h5>Duty Station: {item.location}</h5>
                                        <h5>Grade: {item.grade}</h5>
                                        <h5>Employment Duration: {item.employment_duration}</h5>

                                        <h5>
                                            Learn more about the position:{" "}
                                            <a
                                                href={item.job_description_file}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="btn btn-outline btn-warning btn-sm m-1"
                                                onClick={openReadMore}
                                            >
                                                Read More
                                            </a>
                                        </h5>

                                        <h4>Qualifications and Requirements</h4>
                                        <div className="data-management-container">
                                            <p dangerouslySetInnerHTML={{ __html: item.qualifications_requirements }} />
                                        </div>

                                        <div className="p-2">
                                            <h4 className="text-2xl font-bold mb-4">How to Apply</h4>
                                            <div className="flex flex-wrap">
                                                <p dangerouslySetInnerHTML={{ __html: item.skills }} />
                                            </div>
                                        </div>

                                        <div className="p-2">
                                            <h4 className="text-2xl font-bold mb-4">Job Description</h4>
                                            <div className="flex flex-wrap">
                                                <p dangerouslySetInnerHTML={{ __html: item.description }} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="switchBtn d-flex justify-content-between px-4 py-4">
                                        <div>
                                            <a
                                                className="regBtn"
                                                href={item.apply_link}
                                                target="_blank"
                                                rel="noreferrer"
                                                onClick={openApply}
                                            >
                                                Apply Now
                                            </a>
                                        </div>
                                        <div>
                                            <SocialShareButtons title={item.title} onClick={openShare} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div>
                    <span>Loading...</span>
                </div>
            )}
        </>
    );
}
